import { getI18n } from "react-i18next";

export function formatCurrency(amount: number, currency: string): string {
  const lang = getI18n()?.language || "en";
  return new Intl.NumberFormat(lang, {
    style: "currency",
    currency: currency.toUpperCase(),
  }).format(amount / 100);
}

export function formatDate(dateString?: string): string {
  if (!dateString) return "-";
  const lang = getI18n()?.language || "en";
  return new Date(dateString).toLocaleDateString(lang, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
